
<div class="files-list">
  <div (click)="externalSelectFile(file)" *ngFor="let file of files" [ngClass]="{'file' : mode == '0', 'file-wide': mode == '1', 'selected': isSelected(file)}"  riDraggable [data]="file.toJSON()" [sourceType]="'FILE'" [dragZone]="dragZone">
    <ri-file-component *ngIf="mode == '0'" [file]="file" (onPreviewFile)="openPreview($event)" [selectOnly]="selectOnly" (externalSelect)="externalSelectFile(file)"></ri-file-component>
    <ri-file-wide-component *ngIf="mode == '1'" [file]="file" (onPreviewFile)="openPreview($event)" [selectOnly]="selectOnly" (externalSelect)="externalSelectFile(file)"></ri-file-wide-component>
  </div>
</div>
